<template>
  <el-dialog title="安徽数安系统集成有限公司智慧招采云平台服务协议" :visible.sync="dialogVisible" width="70%" modal-append-to-body
    append-to-body :before-close="handleClose">
    <div class="textDialog">
      <!--      <div>安徽数安系统集成有限公司智慧招采云平台服务协议</div>-->
      <div>
        提示条款:
        欢迎您签署《安徽数安系统集成有限公司智慧招采云平台服务协议》(下称“本协议”)并使用智慧招采云平台服务!
        为维护您自身权益，建议您仔细阅读各条款具体表述。您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体标识，您应重点阅读。如您对协议有任何疑问，可向智慧招采云平台客服咨询。
      </div>
      <div>一、总则</div>
      <div>
        1.1安徽数安系统集成有限公司智慧招采云平台是由安徽数安系统集成有限公司(以下简称“运营方”)创建并运营的电子交易平台。
      </div>
      <div>
        1.2用户在使用招采云平台提供的服务前务必认真阅读本协议，一旦用户使用本平台提供的服务即表示用户同意与本平台签订本协议且同意受本协议及各项相关规则之约束。本协议用于规范运营方与招采云平台用户之间的行为及关系，包括本协议正文及所有招采云平台已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的一部分，与本协议正文具有同等法律效力。本条款所称的用户是指完全同意本协议所有条款并完成注册程序的招采云平台使用者。
      </div>
      <div>
        1.3招采云平台运营方有权利根据需要调整本协议的条款。如本协议有任何变更，运营方将通过招采云平台门户网站刊载公告的方式通知用户，用户理解并同意运营方不再另行发布其他形式的通知。用户对新修改的条款如有异议，在履行完未完成的责任义务后可停止使用招采云平台提供的服务，并申请退出招采云平台。继续使用招采云平台提供的服务即表明用户理解、同意并接受新修订的条款。当用户与招采云平台发生争议时，解决争议时应以最新的服务协议为准。除另行明确声明外，招采云平台运营方任何扩大服务范围或增强功能的新内容均受本协议约束。
      </div>
      <div>
        1.4用户确认:在同意接受本协议并注册成为招采云平台用户时，须具有法律规定的完全民事权利能力和完全民事行为能力，为能够独立承担民事责任的法人或其他组织;本协议内容不受其所属国家或地区的排斥。不具备前述条件的，应立即终止注册或停止使用本服务。招采云平台暂不接受自然人注册。请特别注意:
      </div>
      <div>
        (1)如果用户对本协议的任何条款有异议，可选择不注册为本招采云平台的用户。只要点击本协议正本下方的“我同意”按钮并按照招采云平台注册程序成功注册为用户，该行为即表示同意签署本协议并受本协议及后续平台发布各类规则约束；
      </div>
      <div>
        (2)本协议不涉及注册用户之间因使用招采云平台撮合交易而产生的法律关系及法律纠纷；
      </div>
      <div>
        (3)招采云平台仅作为信息提供平台，不作为任何采购关系权利义务主体，不介入注册用户之间的纠纷。招采云平台各用户利用招采云平台参与相关的电子采购活动，必须对各自的行为承担相应法律责任。
      </div>
      <div>二、招采云平台服务内容</div>
      <div>
        2.1本招采云平台提供的服务主要包括招标、询比、谈判采购、直接采购、竞价、网上商城等多种采购形式。具体内容由本招采云平台根据实际情况提供，并以实际可用的服务为准。运营方有权在必要时变更招采云平台的相关规定及服务内容，并保留随时变更、中断或终止招采云平台的权利，尽可能通过在本招采云平台门户网站上刊登公告的方式通知注册用户。
      </div>
      <div>
        2.2本招采云平台在提供服务时，会明确告知用户需缴纳的相应服务费用。如用户拒绝支付该项费用，将无法获得相关的服务。
      </div>
      <div>
        2.3用户理解：本招采云平台仅作为用户物色交易对象，就工程、货物和服务的交易进行协商，以及获取各类与贸易相关的服务的虚拟场所。招采云平台不能控制交易所涉及的工程、货物、服务的质量、安全或合法性，商贸信息的真实性或准确性，以及交易方履行其在贸易协议项下的各项义务的能力。用户使用招采云平台所需的相关网络服务设备(如电脑、调制解调器及其他与接入互联网有关的装置)及费用(如为接入互联网而支付的电话费及上网费)均应由用户自行负担。为保证所使用网络服务的通畅有效，用户应确保所使用网络连接的高速顺畅。
      </div>
      <div>
        2.4用户对本协议的同意或确认，即表示对本招采云平台所提供功能和服务表示认可。
      </div>
      <div>三、用户使用规则</div>
      <div>
        3.1
        用户在申请使用本招采云平台服务时，必须按照招采云平台要求和提示，准确提供企业及个人资料。倘若提供任何不真实、不准确、不完整或不能反映当前情况的资料，或本招采云平台有合理理由怀疑资料不真实、不准确、不完整或不能反映当前情况，本招采云平台有权暂停或终止该用户的注册身份及资料，并驳回其在目前或将来对“服务”(或其任何部分)以任何形式使用。用户对其在招采云平台提供信息的真实性、准确性和及时性负责，如有提供信息不实等任何违反前述规定的情况，本招采云平台有权依法追究用户由此对招采云平台及相关用户造成损失的责任。
      </div>
      <div>
        3.2用户有权利使用自己的用户名及密码随时登录招采云平台，须自行负责注册名和密码的保密，且须对在该注册名和密码下发生的所有活动承担责任。本招采云平台不能也不会对因其未能遵守本款规定而发生的任何损失或损毁负责。未经本招采云平台书面许可，用户不得将其用户名、密码转售、赠与、转借、租供给第三方或用于商业性用途。否则，由此造成的一切后果和责任由用户自行承担；同时，本招采云平台有权单方面终止为其提供服务。
      </div>
      <div>3.3用户必须同意遵循以下原则，并承担责任:</div>
      <div>(1)遵守中华人民共和国有关的法律和法规；</div>
      <div>(2)不得为任何非法目的而使用招采云平台服务；</div>
      <div>
        (3)遵守本招采云平台所有与服务有关的协议、规定和程序，并接受本招采云平台对用户的管理；
      </div>
      <div>(4)不得利用本招采云平台进行任何可能对互联网的正常运转造成不利影响的行为；</div>
      <div>
        (5)不得利用本招采云平台传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；
      </div>
      <div>(6)不得利用本招采云平台进行任何不利于本招采云平台的行为；</div>
      <div>
        (7)如发现任何非法使用用户名或用户出现安全漏洞的情况，应立即通告本招采云平台；
      </div>
      <div>
        (8)使用招采云平台进行交易过程中应遵守诚实信用的原则，不在交易过程中采取不正当竞争行为，不扰乱网上交易的正常秩序，不从事与网上交易无关的行为；
      </div>
      <div>
        (9)不对招采云平台上任何数据作商业性利用，包括但不限于在未经招采云平台事先书面批准的情况下，以复制、传播等方式使用在招采云平台上展示的任何资料。
      </div>
      <div>四、服务升级、中断或终止</div>
      <div>
        4.1如因系统维护或升级的需要而需暂停服务，本招采云平台将事先在网上进行通告。
      </div>
      <div>
        4.2如用户向招采云平台提出注销招采云平台注册用户身份时，经招采云平台审核同意，由招采云平台注销该注册用户，该用户即解除与招采云平台的协议关系。但注销该用户账号后，招采云平台仍保留下列权利:
      </div>
      <div>(1)注销后，招采云平台有权保留其注册数据及以前的交易行为记录；</div>
      <div>
        (2)注销后，如其在注销前在招采云平台上存在违法行为或违反合同的行为，招采云平台仍可行使本协议所规定的权利。
      </div>
      <div>4.3在下列情况下，招采云平台可以通过注销用户的方式终止服务:</div>
      <div>
        (1)在用户违反本协议相关规定时，招采云平台有权终止向其提供服务。招采云平台将在中断服务时通知该用户。但如其在被招采云平台终止提供服务后，再一次直接或间接或以他人名义注册为招采云平台用户时，招采云平台有权再次单方面终止向其提供服务；
      </div>
      <div>
        (2)一旦招采云平台发现用户的注册数据中主要内容是虚假的，招采云平台有权随时终止向其提供服务；
      </div>
      <div>(3)本协议终止或更新时，用户明示不愿接受新的协议的；</div>
      <div>
        (4)若用户通过网络、短信或热线电话等方式恶意辱骂、骚扰、攻击工作人员时，招采云平台有权随时终止向其提供服务；
      </div>
      <div>(5)其它招采云平台认为需终止服务的情况。</div>
      <div>
        4.4除前款所述情形外，本招采云平台同时保留在事先通知用户的情况下随时中断或终止部分或全部服务的权利，如果用户对上述行为持有异议，可通过本协议约定的方式停止使用相关服务。对于所有服务的中断或终止而造成的任何损失，本招采云平台无需对用户或任何第三方承担任何责任。
      </div>
      <div>五、免责及赔偿</div>
      <div>
        5.1运营方有责任维护好招采云平台的正常运行，但在用户使用服务时，如因不可抗力、计算机病毒或者黑客攻击、系统不稳定、设备故障、数据传输、软件瑕疵、系统升级、设备检修或维护等原因造成服务中断或不能满足用户要求，运营方不承担任何责任。
      </div>
      <div>
        5.2因上述事故造成交易通讯中断或交易数据失真，恢复交易时以故障发生前招采云平台主机最终记录的交易数据为有效数据。
      </div>
      <div>
        5.3招采云平台对服务之及时性、安全性、全面性和准确性不作特别担保，平台用户对自行发布的数据信息的准确性承担责任和后果，招采云平台不承担任何形式的连带责任。
      </div>
      <div>
        5.4用户使用本招采云平台服务所存在的风险及可能造成的损失将完全由其自己承担；因其使用本招采云平台服务而产生的一切后果也由其自己承担，本招采云平台无需对用户或任何第三方承担任何责任。如用户导致招采云平台遭受任何损害或遭受任何来自第三方的纠纷、诉讼和索赔要求等，用户须向招采云平台赔偿相应损失，并需要对其违反本协议所产生的一切后果负全部法律责任，包括但不限于全部直接和间接损失及因索赔导致的诉讼费、仲裁费和律师费等。
      </div>
      <div>六、知识产权</div>
      <div>
        6.1招采云平台上所有内容，包括但不限于文字、图片、网站架构、网站画面的安排、网页设计，均由安徽数安系统集成有限公司依法拥有其知识产权及其他合法权利，包括但不限于商标权、专利权、著作权、商业秘密等。
      </div>
      <div>
        6.2用户不得侵犯第6.1条本招采云平台所享有的知识产权和其他合法权利，包括但不限于只有在获得本招采云平台或其他相关权利人的授权之后才能使用这些内容，不能以擅自复制、再造、传播等方式使用这些内容、或创造与内容有关的派生产品。
      </div>
      <div>
        6.3未经本招采云平台书面许可，用户不得利用本招采云平台所获得的信息用于商业用途，如发现用户与本招采云平台形成竞争或损害本招采云平台的利益，或本招采云平台认为对其正常运营可能造成损害的其他行为，本招采云平台有权单方面终止其使用资格，由此造成的一切后果和责任由用户承担。
      </div>
      <div>七、信息批露</div>
      <div>7.1本招采云平台承诺，其在采购过程中来往的所有文件将不会被恶意泄露。</div>
      <div>
        7.2在使用招采云平台进行网上物色交易对象时，用户不可避免的要向交易对方或潜在的交易对方提供自己的信息。请用户妥善保护相关信息，仅在必要的情形下向他人提供。如果用户发现信息泄密，尤其是招采云平台账户及密码发生泄露，应立即联络招采云平台管理员，以便采取相应措施。
      </div>
      <div>7.3用户信息将在下述情况下按最低限度被招采云平台披露：</div>
      <div>(1)经用户同意，向第三方披露；</div>
      <div>(2)根据法律的有关规定，或者行政或司法机构的要求披露；</div>
      <div>
        (3)如果用户出现违反中华人民共和国有关法律或者招采云平台公布的政策规范的情况，需要向第三方披露；
      </div>
      <div>(4)为提供用户所要求的产品和服务，而必须和第三方分享；</div>
      <div>(5)其它招采云平台根据法律认为合适的披露。</div>
      <div>
        7.4网络环境存在诸多不可预知因素，如用户使用招采云平台时被第三方抓取甚至泄露信息，只要招采云平台并未主动或故意泄露用户隐私，则由用户自行承担风险，运营方不承担任何责任。
      </div>
      <div>
        7.5本协议终止后，除法律、行政法规有明确规定外，运营方无义务向用户或用户指定的第三方披露用户账户中的任何信息。
      </div>
      <div>八、附则</div>
      <div>
        8.1本协议书在用户确认并注册成功后即自动生效，用户确认在每次使用平台前已充分理解并知悉本协议及平台后续发布的各类规则，并承诺一经使用即受上述规定的约束。
      </div>
      <div>
        8.2本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。用户与招采云平台之间发生的任何争议，双方均应本着诚实守信、公平合理的原则友好协商解决。如果双方未能就有关争议达成一致意见，双方约定任何一方应向本招采云平台所在地法院提起诉讼。
      </div>
      <div>
        8.3本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。
      </div>
      <div>
        8.4本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。
      </div>
      <div>8.5本协议由运营方解释及修订。</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="agree">我已阅读并同意协议</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "userText",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("refuse");
    },
    agree() {
      this.$emit("agree");
    },
  },
};
</script>

<style scoped>
.textDialog {
  height: 80vh !important;
  line-height: 23px;
  ovflow-y: auto;
}

::v-deep .el-dialog .el-dialog__body {
  max-height: 100vh;
}
</style>
